import './Loading.css'

const Loading = () => {
  return (
    <div className='loader'>Loading</div>
  )
}

export default Loading